module.exports = __webpack_public_path__ + "img/IMG_9928_L_Black.8be8348e.jpg";